import React from 'react';

const Home = () => {
  return (
    <div className="page about-page">
      <p/>
      <div className="card mt-6">
        <h2 className="card-title">Our Mission</h2>
        <p>
          Our mission is to deliver exceptional engineering consultancy, reporting services, 
          manpower solutions, and digital technology services across aviation, shipping,
           banking, and competitive exam sectors. We strive to empower our clients through 
           advanced technology, strong partnerships, and a commitment to excellence—ensuring 
           the right resources are delivered at the right time. We aim not to be the biggest,
            but to be the best in providing value-driven, reliable, and innovative solutions.
        </p>
      </div>

      <div className="features-grid mt-6">
        <div className="feature-card">
          <div className="feature-icon">🧰</div>
          <h3>Client-Centricity</h3>
          <p>We put clients at the core of every solution, ensuring measurable value and long-term success.</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">⚡</div>
          <h3>Integrity & Transparency</h3>
          <p>We operate with honesty, fairness, and accountability across all engagements.</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">💻</div>
          <h3>Innovation & Technology Excellence</h3>
          <p>We embrace advanced technologies to deliver modern, efficient, and scalable solutions.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">🕎</div>
          <h3>Quality & Reliability</h3>
          <p>We maintain consistent, timely, and high-standard service delivery.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">🤝</div>
          <h3>Collaboration & Partnerships</h3>
          <p>We build strong, lasting relationships that drive collective growth and success.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">👪</div>
          <h3>People First</h3>
          <p>We value our workforce, invest in their growth, and deploy the right talent at the right time.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;